import React from 'react'
import classNames from 'classnames'
import { FlexColumn, FlexRow } from '@/atoms/FlexContainers'
import { CircleInfoIcon } from '@/atoms/Icons/CircleInfoIcon'
import { TicketIcon } from '@/atoms/Icons/TicketIcon'
import { Text } from '@/atoms/Text'
import { slugs } from '@/constants/slugs'
import { useTranslate } from '@/utils/translate/translate-client'
import { GPromoTextSM, GTitleXS } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'

interface GiveawayRefundCardProps {
  className?: string
  title: string
  description: string
  theatricalSlug: string
  onInfoClick?: () => void
}

export const GiveawayRefundCard: React.FC<GiveawayRefundCardProps> = ({
  className,
  title,
  description,
  onInfoClick,
  theatricalSlug,
}) => {
  const { t } = useTranslate('tickets')

  return (
    <FlexColumn
      className={classNames(
        'gap-1 mx-auto w-full border-[2px] border-cool-02 bg-info-100 p-4',
        theatricalSlug === slugs.sketch ? 'rounded-none' : 'rounded-3xl',
        className,
      )}
    >
      <FlexRow className="gap-1">
        <TicketIcon size={20} color="cool-02" />
        <GTitleXS color="giveaway-text-primary-dark">{title}</GTitleXS>
      </FlexRow>
      <GPromoTextSM color="giveaway-text-subtle-light">{description}</GPromoTextSM>
      {theatricalSlug === slugs.homestead && (
        <button onClick={onInfoClick} className="ml-auto flex items-center gap-1">
          <CircleInfoIcon size={16} color="homestead-blue" />
          <Text color="homestead-blue" className="photon-paragraph-sm text-sm underline">
            {t('morePreSaleInfo', 'more info')}
          </Text>
        </button>
      )}

      <button onClick={onInfoClick} className="ml-auto flex items-center gap-1">
        <CircleInfoIcon size={16} color="giveaway-text-subtle-light" />
        <Text color="giveaway-text-subtle-light" className="photon-paragraph-sm text-sm underline">
          {t('morePreSaleInfo', 'more info')}
        </Text>
      </button>
    </FlexColumn>
  )
}
